import { useState } from 'react';
import styled from '@emotion/styled';
import type { MicrositeResponsiveImage } from '~/model';
import MicrositeResponsiveImg from '~/components/MicrositeResponsiveImg';
import { LoadPriority } from '~/hooks/useLoadPriority';

const Section = styled.section`
	background: white;
	padding: 2rem 1.5rem 3rem;
`;

const Inner = styled.div`
	max-width: 72rem;
	margin: 0 auto;
`;

const Grid = styled.div<{ showAll: boolean }>`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 0.5rem;
	@media (min-width: ${(props) => props.theme.viewport.medium}px) {
		grid-template-columns: repeat(4, 1fr);
	}

	${({ showAll }) =>
		!showAll &&
		`
		& > a:nth-of-type(n + 9) {
			display: none;
		}
	`}
`;

const ShowAll = styled.button`
	margin: 2rem auto 0;
	display: flex;
	align-items: center;
	gap: 0.75rem;
	background: white;
	border: 1px solid #d1d5db;
	padding: 0.75rem 1.5rem;
	text-transform: uppercase;
	letter-spacing: 0.08em;
`;

export default function GalleryBlockAlpha({ photos }: { photos: MicrositeResponsiveImage[] }) {
	const [showAll, setShowAll] = useState(false);

	if (photos.length === 0) return null;

	return (
		<Section id="gallery">
			<Inner>
				<Grid showAll={showAll}>
					{photos.map((photo, index) => (
						<a key={index} href="#gallery" data-index={index}>
							<MicrositeResponsiveImg image={photo} priority={LoadPriority.FIRST_PAINT} />
						</a>
					))}
				</Grid>
				{!showAll && (
					<ShowAll type="button" onClick={() => setShowAll(true)}>
						Show all {photos.length} photos
					</ShowAll>
				)}
			</Inner>
		</Section>
	);
}
